export const getSuccessfulMessage = email =>
  `Please check your ${email} inbox for instructions to unlock your account.`
